module.exports = __webpack_public_path__ + "img/paypal.18629f30.png";